const STATE_STYLES = {
  "LIVE": { bg: "#ecfdf5", text: "#047857", border: "#a7f3d0" },
  "BETA": { bg: "#f0f9ff", text: "#0369a1", border: "#bae6fd" },
  "SANDBOX": { bg: "#fff7ed", text: "#c2410c", border: "#ffedd5" },
  "PROVIDER APPROVAL PENDING": { bg: "#fefce8", text: "#a16207", border: "#fef08a" },
  "PENDING": { bg: "#fefce8", text: "#a16207", border: "#fef08a" },
  "COMING SOON": { bg: "#f3f4f6", text: "#4b5563", border: "#e5e7eb" },
  "NOT CONNECTED": { bg: "#fef2f2", text: "#b91c1c", border: "#fecaca" },
  "VERIFIED": { bg: "#ecfdf5", text: "#047857", border: "#a7f3d0" },
  "MISMATCH": { bg: "#fef2f2", text: "#b91c1c", border: "#fecaca" },
  "INCOMPLETE": { bg: "#fefce8", text: "#a16207", border: "#fef08a" },
  "PROCESSING": { bg: "#f0f9ff", text: "#0369a1", border: "#bae6fd" },
  "PASS": { bg: "#ecfdf5", text: "#047857", border: "#a7f3d0" },
  "WARN": { bg: "#fefce8", text: "#a16207", border: "#fef08a" },
};

export function StatusChip({ state, className = "" }) {
  const s = STATE_STYLES[state] || STATE_STYLES["COMING SOON"];
  return (
    <span
      data-testid={`status-chip-${String(state).toLowerCase().replace(/\s+/g, "-")}`}
      className={`inline-flex items-center gap-1 rounded-md border px-2 py-0.5 font-mono text-[10px] font-semibold uppercase tracking-wider ${className}`}
      style={{ background: s.bg, color: s.text, borderColor: s.border }}
    >
      <span className="h-1.5 w-1.5 rounded-full" style={{ background: s.text }} />
      {state}
    </span>
  );
}
